// extracted by mini-css-extract-plugin
export var functionLabel = "Nav-module__functionLabel";
export var functionName = "Nav-module__functionName";
export var navigationSelect = "Nav-module__navigation-select";
export var navigationSelectSuffix = "Nav-module__navigationSelectSuffix";
export var root = "Nav-module__root";
export var selectContainer = "Nav-module__selectContainer";